'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_display_Accordion_Accordion = require('../../display/Accordion/Accordion.cjs.js');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
const components_display_Heading_HeadingLevel = require('../../display/Heading/HeadingLevel.cjs.js');
const components_navigation_Button_Button = require('../../navigation/Button/Button.cjs.js');

const Styles = styleEncapsulation.labelStyles("FAQ", {
  root: react.css`
    padding: var(--zds-space-32) var(--zds-space-20);

    @media screen and (min-width: 650px) {
      padding: var(--zds-space-48) var(--zds-space-32);
    }
  `,
  faqContent: react.css`
    max-width: 1170px;
    margin: 0 auto;
  `,
  heading: react.css`
    margin-bottom: var(--zds-space-32);
    font: var(--zds-section-header);
    color: var(--zds-text-stronger);
  `,
  ctaContainer: react.css`
    margin-top: var(--zds-space-32);

    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 650px) {
      margin-top: var(--zds-space-32);
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
  grid: react.css`
    display: grid;
    gap: var(--zds-space-20);

    @media screen and (min-width: 650px) {
      gap: var(--zds-space-16);
    }
  `
});
const FAQ = ({ heading = "Frequently Asked Questions", items, children, ctaText, ctaHref, onCtaClick }) => {
  return react.jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    react.jsx(
      "div",
      { css: Styles.faqContent, "data-zds": true },
      react.jsx(
        components_display_Heading_HeadingLevel.HeadingLevel,
        null,
        react.jsx(components_display_Heading_Heading.Heading, { css: Styles.heading }, heading)
      ),
      items && items.length > 0 ? react.jsx("div", { css: Styles.grid, "data-zds": true }, items.map((item) => react.jsx(components_display_Accordion_Accordion.Accordion, { key: item.title, title: item.title, href: item.href, isInitiallyOpen: item.isInitiallyOpen, isOpen: item.isOpen, onToggle: item.onToggle }, item.content))) : children,
      ctaText && (ctaHref || onCtaClick) && react.jsx(
        "div",
        { css: Styles.ctaContainer, "data-zds": true },
        react.jsx(components_navigation_Button_Button.Button, { href: ctaHref, size: "medium", onClick: onCtaClick }, ctaText)
      )
    )
  );
};

exports.FAQ = FAQ;
//# sourceMappingURL=FAQ.cjs.js.map
